package ui.server.detail

import androidx.compose.runtime.*
import common.frontend.api.*
import io.*
import kotlinx.browser.*
import kotlinx.coroutines.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.utils.*
import tools.*

@VM
class ServerVM : NavigationViewModel() {


    private lateinit var scopeUi: ServerScope

    var isServerSwitching by mutableStateOf(false)
        private set

    var state by mutableDataState<ServerScope.Wrapper>()
        private set


    sealed interface Action {

        data object Save : Action
        data object Lock : Action
        data object Delete : Action
        data object Swap : Action
        companion object {

            @Composable
            fun rememberAction(vm: ServerVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            Save -> vm.save()
                            Delete -> vm.delete()
                            Swap -> vm.swap()
                            Lock -> vm.lock()
                        }
                    }
                }
            }
        }
    }

    private fun swap() {
        isServerSwitching = true
        scope.launch {
            state.entry
                ?.runCatching {
                    Repository.api.server.swap(data.id)
                    window.location.reload()
                }
                ?.onFailure {
                    it.printStackTrace()
                    ui.snackBarStateGlobal.showSnackbar(it.message!!, withDismissAction = true)
                    isServerSwitching = false
                }
        }
    }

    private fun save() {
        scope.launch {
            state.entry
                ?.runCatching {
                    Repository.api.server.edit(data)
                    this
                }
                ?.onFailure { it.printStackTrace() }
                ?.onSuccess { it.applyChanges() }
        }
    }

    private fun lock() {
        scope.launch {
            state.entry
                ?.runCatching {
                    Repository.api.server.lock(data.id)
                    this
                }
                ?.onFailure { it.printStackTrace() }
                ?.onSuccess { it.makeLock() }
        }
    }

    private fun delete() {
        scope.launch {
            runCatching {
                Repository.api.server.delete(scopeUi.args.serverId)
            }.onSuccess {
                scopeUi.nav.up()
            }.onFailure {
                it.printStackTrace()
            }
        }
    }


    fun init(scopeUi: ServerScope) {
        this.scopeUi = scopeUi
        if (state is DataState.Result) return

        scope.launch {
            runCatching {
                val server = Repository.api.server.single(scopeUi.args.serverId)
                state = DataState.Result(
                    ServerScope.Wrapper(
                        canEdit = scopeUi.login.canServerEdit(serverId = server.id),
                        canDelete = scopeUi.login.canServerDelete(serverId = server.id),
                        canSwap = scopeUi.login.canServerAdd() && scopeUi.login.server.id != server.id,
                        data = server
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(Res.string.err_connection_fail.await())
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }

}
